import React, { useRef } from "react";
import close from "../../assets/images/close.svg";
import iconDropDown from "../../assets/images/icondropdown.svg";

const RefundPopup = ({
    show,
    onClose,
    refundType,
    setRefundType,
    refundAmount,
    setRefundAmount,
    refundReason,
    setRefundReason,
    refundReasonOptions,
    finalTotal,
    openRefundReason,
    setOpenRefundReason,
    onSubmit,
    styles,
    reference
}) => {
    const refundReasonDropdownRef = useRef();

    if (!show) return null;

    return (
        <>
            <div className="popup-overlay"></div>
            <div className="popup-box add-new-user add-refund" ref={reference}>
                <div className="popupTop popupTopClose closePlan previewClose">
                    <img src={close} onClick={() => onClose()} alt="Icon" />
                </div>
                <div className='popupModalTitle'>Add Refund</div>
                <div className="popup-form">
                    {/* Refund Type */}
                    <div className="form-group">
                        <div className={styles.discountSection}>
                            {["full", "partial"].map((type) => (
                                <div key={type} className={styles.radioButtonGroup}>
                                    <input
                                        type="radio"
                                        name="refundType"
                                        value={type}
                                        checked={refundType === type}
                                        onChange={(e) => setRefundType(e.target.value)}
                                        className="custom-radio"
                                    />
                                    <label>
                                        <span>{type === "full" ? "Full Refund" : "Partial Refund"}</span>
                                    </label>
                                </div>
                            ))}
                        </div>

                    </div>
                    <div className="form-group">
                        {/* Amount */}
                        {refundType === "partial" && (
                            <input
                                type="number"
                                min={0}
                                max={finalTotal}
                                className='form-input'
                                value={refundAmount}
                                onChange={(e) => setRefundAmount(Number(e.target.value) || 0)}
                                placeholder="Enter refund amount"
                            />
                        )}
                    </div>

                    {/* Reason */}
                    <div className="dropdown-wrapper" ref={refundReasonDropdownRef}>
                        <div
                            className="dropdown-header"
                            onClick={() => setOpenRefundReason(!openRefundReason)}
                        >
                            <span className="title">
                                {refundReasonOptions
                                    .flatMap((g) => g.reasons)
                                    .find((r) => r.value === refundReason)?.label || "Select Reason"}
                            </span>
                            <img src={iconDropDown} alt="dropdown-image"/>
                        </div>

                        {openRefundReason && (
                            <div className="dropdown-list">
                                {refundReasonOptions.map((group) => (
                                    <div key={group.category}>
                                        <div className="reason-category">{group.category}</div>
                                        {group.reasons.map((reason) => (
                                            <div
                                                key={reason.value}
                                                className="dropdown-item"
                                                onClick={() => {
                                                    setRefundReason(reason.value);
                                                    setOpenRefundReason(false);
                                                }}
                                            >
                                                {reason.label}
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                <div className="popup-actions">
                    <button className="cancel-btn" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="save-btn" onClick={onSubmit}>
                        Process Refund
                    </button>
                </div>
            </div>
        </>
    );
};

export default RefundPopup;
